import React from "react";
import PageLoader from "@/components/PageLoader";

// Matches the zero-JS static splash in public/index.html so there's no visual jump between
// "before React mounts" and "React is checking the session" — same black background, same
// dot-ring animation as every other in-app loading state (PageLoader). Shown while
// AuthContext verifies the session on cold start, and whenever a fresh tab (e.g. a
// document opened via target="_blank") re-runs that check from scratch.
export default function SplashScreen() {
  return (
    <div className="fixed inset-0" style={{ background: "#000000" }}>
      <PageLoader fullScreen />
    </div>
  );
}
